module.exports = __webpack_public_path__ + "img/trophy-01.4f984f9a.svg";